export default __webpack_public_path__ + "static/media/LockIcon.3e9a2f17.svg";